jQuery(document).foundation();

var wow = new WOW(
  {
    boxClass:     'wow',      // animated element css class (default is wow)
    animateClass: 'animated', // animation css class (default is animated)
    offset:       0,          // distance to the element when triggering the animation (default is 0)
    mobile:       false       // trigger animations on mobile devices (true is default)
  }
);
wow.init();


jQuery(document).ready(function($){
  
jQuery('ul.products').infinitescroll({
  loading: {
    finished: undefined,
    finishedMsg: "<em>All Items Loaded.</em>",
    img: '//cdn.shopify.com/s/files/1/0055/8094/7525/t/2/assets/ajax-loader.gif?v=95442690028225377921539022485',
    msg: null,
    msgText: "<em>Loading Items...</em>",
    selector: null,
    speed: 'slow',
    start: undefined
},
  binder: $(window), // used to cache the selector for the element that will be scrolling
  nextSelector: "ul.pagination a:first",
  navSelector: "ul.pagination",
  itemSelector: "ul.products li.product",
});

  
  
  
});


function newPopup(url) {
	popupWindow = window.open(
		url,'popUpWindow','height=400,width=523,left=10,top=10,resizable=yes,scrollbars=no,toolbar=yes,menubar=no,location=no,directories=no,status=yes')
}

jQuery(function() {
          jQuery('.swatch :radio').change(function() {
            var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
            var optionValue = jQuery(this).val();
            jQuery(this)
            .closest('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
          }); 
        });